import { SAVE_ATTENDEE_TYPE_DATA, UPDATE_ATTENDEE_TYPE_STATUS } from "./types";
export function saveAttendeeTypeData(data) {
    return {
        type: SAVE_ATTENDEE_TYPE_DATA,
        payload: data,
    };
}
export function UpdateAttendeeTypeStatus(isLoading) {
    return {
        type: UPDATE_ATTENDEE_TYPE_STATUS,
        payload: isLoading,
    };
}
